import { RegisterOptions } from 'react-hook-form'

export const registrationValidation: { [x: string]: RegisterOptions } = {
  firstName: {
    required: {
      value: true,
      message: 'This field is required'
    }
  },
  lastName: {
    required: {
      value: true,
      message: 'This field is required'
    }
  },
  emailAddress: {
    required: {
      value: true,
      message: 'This field is required'
    },
    pattern: {
      // Matches email addresses
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: 'Invalid email address'
    }
  },
  password: {
    required: {
      value: true,
      message: 'This field is required'
    },
    minLength: {
      value: 6,
      message: 'Must be at least 6 characters long'
    }
  },
  phoneNumber: {
    pattern: {
      // Matches phone numbers
      value: /^[0-9]{3}[0-9]{3}[0-9]{4}$/,
      message: 'Invalid phone number'
    }
  },
  agreeTerms: {
    required: {
      value: true,
      message: 'This field is required'
    }
  }
}
